export const MESSAGE_TAG_HEADERS = ["Name", "Metadata", "Actions"];

export const MESSAGE_TAG_ACTIONS = {
    EDIT: "EDIT",
    DELETE: "DELETE",
};
